import React, { useEffect, useState } from "react";
import SliderOptions from "../sliderOptions";
import {
  Pencil,
  Trash2,
  Plus,
  Search,
  X,
  Loader2,
} from "lucide-react";
import { adminDashboardApi } from "../../../supports/adminDashboardApi";
import { generateRequestId } from "../../../common/common";
import { useToast } from "../../../common/toastSystem";
import Loader from "../../../common/loader";
const Entities = () => {
  const [tab, setTab] = useState("Candidate");
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [addEditModalOpen, setaddEditModalOpen] = useState({
    state: false,
    type: "add",
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [initialCategories, setInitialCategories] = useState([]);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [fetchEntityLoading, setFetchEntityLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [deleteCategoryItem, setDeleteCategoryItem] = useState(null);
  const [handleCrudApiLoading, setHandleCrudApiLoading] = useState(false);
  const [projectPhases, setProjectPhases] = useState([]);
const [activities, setActivities] = useState([]);
const [sectors, setSectors] = useState([]);
const [validationErrors, setValidationErrors] = useState({});
    // controls container enter animation when table data is loaded
    const [containerVisible, setContainerVisible] = useState(false);
const toast = useToast();  const handleTabChange = (value) => {
    setTab(value);
  };


  const excludeKeys = [
  "broadbean_source_name",
  "activity_libelle",
  "phase_libelle",
  "id",
  "sector_libelle",
  "sector_id"

];


  useEffect(() => {
    // Fetch categories data from API or define it here
    getallEntities();
  }, [tab]);

  const getallEntities = async () => {
    try {
      setIsCategoryLoading(true);
      setContainerVisible(false);
      let payload = {
        entity_type: tab?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      const response = await adminDashboardApi.getallEntities(payload);
      if (response && response.success) {
        let collectedData = response?.data?.data || [];
        const formattedData = collectedData.map((item) => {
          const name = item.value
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          return {
            ...item,
            name,
          };
        });

        if (tab === "Candidate") {
          let data = formattedData.filter(
            (item) => item.name !== "Service Type"
          );
          setInitialCategories(data || []);
        } else {
          setInitialCategories(formattedData || []);
        }

        setSelectedCategory(formattedData[0] || null);
        fetchEntityItems(formattedData[0]?.value);
      } else {
        setInitialCategories([]);
      }
      setIsCategoryLoading(false);
    } catch (error) {
      setIsCategoryLoading(false);
      console.error("Error fetching entities:", error);
    }
  };

  const handleCategoryChange = async (category) => {
    setSelectedCategory(category);
    if (category?.name === "Project Phase Activity") {
      fetchProjectPhaseItems(category?.value);
    }else if(category?.name === "Sub Sector") {
      fetchSubSectorItems(category?.value)
    }
    else {
      fetchEntityItems(category?.value);
    }
  };

  const fetchSectorList = async () => {
    try {
      setIsCategoryLoading(true);
      const payload = {
        table_name: "sector",
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      const response = await adminDashboardApi.fetchEntityItems(payload);
      if (response && response.success) {
        setSectors(response.data?.items || []);
      } else {
        setSectors([]);
      }
    } catch (error) {
      console.error("Error fetching sectors:", error);
      setSectors([]);
    } finally {
      setIsCategoryLoading(false);
    }
  };

  const fetchEntityItems = async (category) => {
    try {
      setFetchEntityLoading(true);
      setContainerVisible(false);
      let payload = {
        table_name: category,
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      let response = await adminDashboardApi.fetchEntityItems(payload);
      if (response && response.success) {
        const items = response?.data?.items || [];
        setTableData(items);
        // trigger container enter animation if we have rows
        if (items.length > 0) {
          setTimeout(() => setContainerVisible(true), 30);
        } else {
          setContainerVisible(false);
        }
      } else {
        setTableData([]);
        setContainerVisible(false);
      }
      setFetchEntityLoading(false);
    } catch (error) {
      setFetchEntityLoading(false);
      console.error("Error fetching entity items:", error);
    }
  };
  const fetchProjectPhaseItems = async () => {
    try {
      setFetchEntityLoading(true);
      setContainerVisible(false);
      let payload = {
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      let response = await adminDashboardApi.fetchProjectPhaseActivity(payload);
      if (response && response.success) {
        const items = response?.data?.items || [];
        setTableData(items);
        if (items.length > 0) {
          setTimeout(() => setContainerVisible(true), 30);
        } else {
          setContainerVisible(false);
        }
      } else {
        setTableData([]);
        setContainerVisible(false);
      }
      setFetchEntityLoading(false);
    } catch (error) {
      setFetchEntityLoading(false);
      console.error("Error fetching entity items:", error);
    }
  };

    const fetchSubSectorItems = async () => {
    try {
      setFetchEntityLoading(true);
      setContainerVisible(false);
      let payload = {
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      let response = await adminDashboardApi.fetchSubSector(payload);
      if (response && response.success) {
        const items = response?.data?.items || [];
        setTableData(items);
        if (items.length > 0) {
          setTimeout(() => setContainerVisible(true), 30);
        } else {
          setContainerVisible(false);
        }
      } else {
        setTableData([]);
        setContainerVisible(false);
      }
      setFetchEntityLoading(false);
    } catch (error) {
      setFetchEntityLoading(false);
      console.error("Error fetching entity items:", error);
    }
  };
  const handleOpenAdd = () => {
    if (selectedCategory?.name === "Project Phase Activity") {
      setFormData({ project_phase_id: "", activity_id: "" });
      fetchAcitvityAndProjectPhaseData();
    } else if (selectedCategory?.name === "Sub Sector") {
      setFormData({ code: "", name: "", sector_ids: [] });
      setValidationErrors({});
      fetchSectorList();
      setaddEditModalOpen({ state: true, type: "Add" });
    } else {
      setFormData({});
      setaddEditModalOpen({ state: true, type: "Add" });
    }
    setSelectedItem(null);
  };

  const fetchAcitvityAndProjectPhaseData = async () => {
    try {
      const payloadA = {
        table_name: "activity",
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      const payloadB = {
        table_name: "project_phase",
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      const [activityResponse, projectPhaseResponse] = await Promise.all([
        adminDashboardApi.fetchEntityItems(payloadA),
        adminDashboardApi.fetchEntityItems(payloadB),
      ]);
      if (
        activityResponse &&
        activityResponse?.success &&
        projectPhaseResponse &&
        projectPhaseResponse?.success
      ) {
        if (activityResponse.data?.items?.length > 0) {
          setActivities(activityResponse.data.items);
        } else {
          setActivities([]);
        }
        if (projectPhaseResponse.data?.items?.length > 0) {
          setProjectPhases(projectPhaseResponse.data.items);
        } else {
          setProjectPhases([]);
        }
        setaddEditModalOpen({ state: true, type: "Add" });
      } else {
        toast.warning("Failed to get the data . please try again later");
      }
    } catch (error) {
      console.log("Error in fetchAcitvityAndProjectPhaseData" + error);
    }
  };

  const handleEdit = (item) => {
    if (selectedCategory?.name === "Sub Sector") {
      // ensure we have sectors for selection
      fetchSectorList();
      // normalize sector ids if available on item
      const sectorIds = item?.sector_ids || (item?.sector_id ? [item.sector_id] : []);
      setValidationErrors({});
      setFormData({
        id:item.id,
        code: item?.code ?? "",
        name: item?.name ?? item?.libelle ?? "",
        sector_ids: sectorIds,
      });
    } else {
      setFormData({ ...item });
    }
    setSelectedItem(item);
    setaddEditModalOpen({ state: true, type: "Edit" });
  };

  const handleCrudOperations = async () => {
    try {
      setHandleCrudApiLoading(true);

      // ---------- Build Payload ----------
      let payload;
      const baseUserPayload = {
        request_id: generateRequestId(),
        email: "abc",
        tenant: "ABC",
      };

        // Special handling for Sub Sector payload shape
        if (selectedCategory?.name === "Sub Sector") {
          // Delete flow: when user confirmed deleteCategoryItem is set
          if (deleteCategoryItem) {
            payload = {
              subsector_id: deleteCategoryItem,
              delete: true,
              data: {},
              user_payload: baseUserPayload,
            };
          } else if (addEditModalOpen.type === "Add") {
            // Add new subsector
            payload = {
              data: {
                code: Number(formData.code),
                name: formData.name,
                sector_ids: (formData.sector_ids || []).map(Number),
              },
              user_payload: baseUserPayload,
            };
          } else {
            // Edit existing subsector
            payload = {
              subsector_id: selectedItem?.id || formData?.id,
              delete: false,
              data: {
                ...(formData.name && { name: formData.name }),
                ...(formData.sector_ids && { sector_ids: (formData.sector_ids || []).map(Number) }),
              },
              user_payload: baseUserPayload,
            };
          }
      } else if (selectedCategory?.name === "Project Phase Activity") {
        // Special handling for Project Phase Activity
        if (deleteCategoryItem && typeof deleteCategoryItem === "object") {
          payload = {
            project_phase_id: deleteCategoryItem?.project_phase_id,
            activity_id: deleteCategoryItem?.activity_id,
            delete: true,
            data: {},
            user_payload: baseUserPayload,
          };
        } else if (addEditModalOpen.type === "Add") {
          payload = {
            data: {
              project_phase_id: Number(formData.project_phase_id),
              activity_id: Number(formData.activity_id),
            },
            user_payload: baseUserPayload,
          };
        } else {
          payload = {
            data: {
              project_phase_id: Number(formData.project_phase_id),
              activity_id: Number(formData.activity_id),
            },
            ...(selectedItem?.id && { id: selectedItem?.id }),
            user_payload: baseUserPayload,
          };
        }
      } else {
        // default payload
        payload = deleteCategoryItem
          ? {
              id: deleteCategoryItem,
              data: {},
              delete: true,
              user_payload: baseUserPayload,
            }
          : {
              data: formData,
              ...(addEditModalOpen.type === "Edit" && { id: selectedItem?.id }),
              user_payload: baseUserPayload,
            };
      }

      console.log("Submitting:", addEditModalOpen.type, payload);

      // ---------- API Map (Category → API Functions) ----------
      const apiMap = {
        Activity: {
          add: adminDashboardApi.addActivityEntity,
          update: adminDashboardApi.updateDeleteActivityEntity,
        },
        Country: {
          add: adminDashboardApi.addCountryEntity,
          update: adminDashboardApi.updateDeleteCountryEntity,
        },
        "Cv Origin": {
          add: adminDashboardApi.addCvOriginEntity,
          update: adminDashboardApi.updateCvOriginEntity,
        },
        "Education Level": {
          add: adminDashboardApi.addEducationEntity,
          update: adminDashboardApi.updateEducationEntity,
        },
        Experience: {
          add: adminDashboardApi.addExperienceEntity,
          update: adminDashboardApi.updateExperienceEntity,
        },
        Language: {
          add: adminDashboardApi.addLanguageEntity,
          update: adminDashboardApi.updateLanguageEntity,
        },
        "Language Level": {
          add: adminDashboardApi.addLanguageLevelEntity,
          update: adminDashboardApi.updateLanguageLevelEntity,
        },
        "Project Phase": {
          add: adminDashboardApi.addProjectPhaseEntity,
          update: adminDashboardApi.updateProjectPhaseEntity,
        },
        Sector: {
          add: adminDashboardApi.addSectorEntity,
          update: adminDashboardApi.updateSectorEntity,
        },
        "Moby Status": {
          add: adminDashboardApi.addMobyStatusEntity,
          update: adminDashboardApi.updateMobyStatusEntity,
        },
        "Project Phase Activity": {
          add: adminDashboardApi.addProjectPhaseActivity,
          update:adminDashboardApi.updateProjectPhaseActivity
        },
        "Service Type": {
          add: adminDashboardApi.addServiceTypeEntity,
          update: adminDashboardApi.updateServiceTypeEntity,
        },
        "Sub Sector":{
          add: adminDashboardApi.addSubSectorEntity,
          update:adminDashboardApi.updateSubSectorEntity
        }
      };

      const category = selectedCategory.name;
      const action =
        addEditModalOpen.type === "Add" && !deleteCategoryItem
          ? "add"
          : "update";

      const apiFn = apiMap[category]?.[action];

      if (!apiFn) {
        toast.error("Invalid category or API mapping missing");
        return;
      }

      // ---------- Call API ----------
      const response = await apiFn(payload);

      // ---------- Toast Messaging ----------
      if (response?.success) {
        toast.success(response.message);
        if (action === "add") {
          setInitialCategories((prev) =>
            prev.map((item) =>
              item.name === category
                ? { ...item, count: item?.count + 1 }
                : item
            )
          );
          setSelectedCategory((prev) => ({
            ...prev,
            count: prev.count + 1,
          }));
        } else {
          if (deleteCategoryItem) {
            setInitialCategories((prev) =>
              prev.map((item) =>
                item.name === category
                  ? { ...item, count: item?.count - 1 }
                  : item
              )
            );
            setSelectedCategory((prev) => ({
              ...prev,
              count: prev.count - 1,
            }));
          }
        }
      } else {
        toast.warning(response?.message);
      }
      if (category !== "Project Phase Activity" && category !== 'Sub Sector') {
        await fetchEntityItems(selectedCategory?.value);
      }else if(category === "Sub Sector"){
        await fetchSubSectorItems()
      }
       else {
        await fetchProjectPhaseItems();
      }
    } catch (error) {
      console.error("Submit error:", error);

      toast.error("Something went wrong. Try again.");
    } finally {
      setDeleteCategoryItem(null);
      setDeleteModalOpen(false);
      setHandleCrudApiLoading(false);
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    setaddEditModalOpen({ state: false, type: "Add" });
    setFormData({});
    setSelectedItem(null);
    setValidationErrors({});
  };

  const handleAddSector = () => {
    // Logic to handle adding a new sector
    alert("Add Sector button clicked");
  };

  const validateField = (key, value, isEdit) => {
    if (!value?.toString().trim()) {
      return null;
    }
    const trimmed = value.toString().trim();

    // Sub Sector uses different field names in tableData (e.g. libelle/name and code).
    if (selectedCategory?.name === "Sub Sector") {
      return tableData.some((item) => {
        if (isEdit && selectedItem?.id === item.id) return false;
        if (key === "code") {
          // Compare codes as exact numeric strings to avoid false positives
          const itemCode = String(item.code ?? "").trim();
          return itemCode === trimmed;
        }
        if (key === "name") {
          return (
            String(item.name || item.libelle || "").trim().toLowerCase() ===
            trimmed.toLowerCase()
          );
        }
        return false;
      })
        ? "Already exists"
        : null;
    }

    // Generic check for other categories
    return tableData.some((item) => {
      if (isEdit && selectedItem?.id === item.id) {
        return false;
      }
      return String(item[key] || "").trim()?.toLowerCase() === trimmed?.toLowerCase();
    })
      ? "Already exists"
      : null;
  };

  // Safely format a table cell value for rendering. Handles primitives, arrays, and objects.
  const formatCell = (value) => {
    if (value === null || value === undefined) return "";
    if (Array.isArray(value)) {
      return value
        .map((v) => {
          if (!v && v !== 0) return "";
          if (typeof v === "object") {
            return v.libelle || v.name || v.value || JSON.stringify(v);
          }
          return String(v);
        })
        .filter(Boolean)
        .join(", ");
    }
    if (typeof value === "object") {
      return value.libelle || value.name || value.value || value.sector_libelle || JSON.stringify(value);
    }
    return String(value);
  };

  let filteredTableData = [];

  try {
    filteredTableData = tableData.filter((item) => {
      return Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm?.toLowerCase().trim())
      );
    });
  } catch (error) {
    console.error("Error filtering table data:", error);
    filteredTableData = []; // fallback to empty list
  }

  const hasValidationErrors = Object.values(validationErrors).some(Boolean);

  // Compute required fields. For most categories, derive from tableData keys,
  // but for Sub Sector we want to use the form keys we render (`code`, `name`, `sector_ids`).
  const requiredFields = (() => {
    if (selectedCategory?.name === "Sub Sector") {
      // on Add require code,name,sector; on Edit require name,sector
      return addEditModalOpen.type === "Add"
        ? ["code", "name", "sector_ids"]
        : ["name", "sector_ids"];
    }
    return tableData.length > 0
      ? Object.keys(tableData[0]).filter((key) => !excludeKeys.includes(key))
      : [];
  })();

  const hasEmptyRequiredFields = selectedCategory?.name === "Sub Sector" ? false : requiredFields.some((key) => {
    const raw = formData[key];
    // handle arrays (sector_ids) and other types
    const val = Array.isArray(raw) ? raw.length > 0 ? raw.toString().trim() : "" : (raw?.toString().trim() ?? "");
    return val === "";
  });

  let isSubmitDisabled = handleCrudApiLoading || hasValidationErrors || hasEmptyRequiredFields;

  if (addEditModalOpen.state && selectedCategory?.name === "Sub Sector") {
    const missing = addEditModalOpen.type === "Add"
      ? (!formData.code || !formData.name || !(formData.sector_ids && formData.sector_ids.length))
      : (!formData.name || !(formData.sector_ids && formData.sector_ids.length));
    isSubmitDisabled = isSubmitDisabled || missing;
  }

  return (
    <main>
      <div className="backdrop-blur-sm px-5 py-6">
        <div className="mb-2">
           <h1 className="text-base font-bold text-gray-333">
            Entities Management
           </h1>
          <div className="text-gray-500 text-xs">
            Manage system entities and their data
          </div>
        </div>
        {/* <div>
          <SliderOptions
            options={["Candidate"]}
            defaultValue={tab}
            onChange={(value) => {
              handleTabChange(value);
            }}
          />
        </div> */}

        {
          <>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 py-2">
  {initialCategories.map((item, index) => (
    <div
      key={index}
      onClick={() => handleCategoryChange(item)}
      className={`
        flex items-center justify-between 
        text-xs border border-[#f4e4c6] 
        px-4 py-2.5 rounded-xl shadow-sm cursor-pointer 
        hover:bg-[#fff3e0] hover:scale-105 active:scale-[0.97] 
        hover:shadow-md transition-all duration-200 ease-in-out
        ${selectedCategory?.name === item.name ? "bg-[#fff3e0] ring-1 ring-[#f4e4c6]" : "bg-white"}
      `}
    >
      {/* Name - Truncated if too long to keep cards uniform */}
      <span className="font-medium text-gray-700 truncate mr-3">
        {item.name}
      </span>

      {/* Value/Count */}
      <span className={` border border-[#f4e4c6] text-[10px] font-bold rounded-md px-2 py-0.5 text-gray-600 shrink-0 ${selectedCategory?.name === item.name ? 'bg-[#ffdfb8]' : 'bg-gray-100'}`}>
        {item.count}
      </span>
    </div>
  ))}
</div>
            {/* <div className="flex flex-wrap gap-3 py-2">
              {initialCategories.map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleCategoryChange(item)}
                  className={`flex items-center justify-between text-xs  border border-[#f4e4c6] px-3 py-1 rounded-full shadow-sm cursor-pointer hover:bg-[#fff3e0] hover:scale-105 active:scale-[0.97] hover:shadow-md transition-all duration-200 ease-in-out ${
                    selectedCategory?.name === item.name
                      ? "bg-[#fff3e0]"
                      : "bg-white"
                  }`}
                >
                  <span className="mr-2">{item.name}</span>
                  <span className="bg-gray-100 border border-[#f4e4c6] text-[10px] font-semibold rounded-full px-2 py-[2px]">
                    {item.count}
                  </span>
                </div>
              ))}
            </div> */}

            {fetchEntityLoading ? (
              <div className="flex justify-center items-center h-40">
               <Loader message="Loading Data"></Loader>
              </div>
            ) : (
              <>
                {tableData.length === 0 && !fetchEntityLoading && (
                  <div className="flex flex-col justify-center items-center h-40 text-gray-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-12 w-12 mb-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    <p>No data available for {selectedCategory?.name}.</p>
                  </div>
                )}

                {/* Table Section */}
                {tableData.length > 0 && (
                  <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
                    <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
                      <div className="flex items-center">
                        <h2 className="text-sm font-semibold text-gray-800">
                          {selectedCategory?.name} Data
                        </h2>
                        <span className="bg-gray-100 ml-4 flex px-3 py-2 rounded-full text-gray-500 text-xs">
                          {selectedCategory.count}
                        </span>
                      </div>

                      <div className="flex items-center gap-3">
                        {/* Search Bar */}
                        <div className="relative">
                          <Search
                            size={14}
                            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                          />
                          <input
                            type="text"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pl-8 pr-3 py-1.5 text-xs border border-gray-200 rounded-full bg-gray-50 focus:outline-none focus:ring-1 focus:ring-[#b2853d] w-48 transition-all duration-200 focus:scale-102 hover:border-[#b2853d] hover:shadow-sm"
                          />
                        </div>

                        {/* Add Button */}
                        <button
                          onClick={handleOpenAdd}
                          className="flex items-center gap-1 bg-[#b2853d] text-white text-xs px-3 py-1.5 rounded-full hover:bg-[#9a6e2d] hover:scale-105 active:scale-95 hover:shadow-lg transition-all duration-200 ease-in-out"
                        >
                          <Plus size={14} /> Add
                        </button>
                      </div>
                    </div>

                    {filteredTableData.length === 0 &&
                      searchTerm.trim() !== "" && (
                        <div className="px-4 py-4 text-sm text-gray-300 text-center">
                          No records found for the searched item
                        </div>
                      )}

                    {filteredTableData.length === 0 &&
                      searchTerm.trim() === "" && (
                        <div className="px-4 py-4 text-sm text-gray-300 text-center">
                          No records found
                        </div>
                      )}

                    {/* Table */}
                    {filteredTableData.length > 0 && (
                      <div className="max-h-[calc(100vh-320px)] overflow-auto  scroll-smooth">

                      <table className="w-full text-xs text-gray-700">
                        <thead className="bg-gray-50 text-gray-500 uppercase border-b border-gray-100">
                          <tr>
                            {tableData.length > 0 &&
                              Object.keys(tableData[0]).map((key) => (
                                <th
                                  key={key}
                                  className="px-4 py-2 text-left font-medium"
                                >
                                  {key
                                    .split("_")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ")}
                                </th>
                              ))}
                            <th className="px-4 py-2"></th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {filteredTableData.map((item, index) => (
                            <tr
                              key={index}
                              className={`transform transition-all duration-300 ease-out hover:bg-gray-50 hover:shadow-sm ${containerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'}`}
                              style={{ transitionDelay: `${index * 40}ms` }}
                            >
                              {Object.values(item).map((value, i) => (
                                <td
                                  key={i}
                                  className="px-4 py-3 whitespace-nowrap"
                                >
                                  {formatCell(value)}
                                </td>
                              ))}
                              <td className="px-4 py-3 whitespace-nowrap">
                                <div className="flex justify-end gap-2">
                                  {selectedCategory.name !==
                                    "Project Phase Activity" && (
                                    <button
                                      title="Edit"
                                      onClick={() => handleEdit(item)}
                                      className="border border-gray-200 rounded-full p-1.5 hover:bg-gray-100 hover:scale-110 active:scale-95 hover:shadow-md transition-all duration-200 ease-in-out"
                                    >
                                      <Pencil
                                        size={14}
                                        className="text-gray-600"
                                      />
                                    </button>
                                  )}

                                  <button
                                    title="Delete"
                                    onClick={() => {
                                      setDeleteCategoryItem(selectedCategory?.name === "Project Phase Activity" ? item : (item?.id ?? item?.project_phase_id));
                                      setDeleteModalOpen(true);
                                    }}
                                    className=" border border-gray-200 rounded-full  p-1.5 hover:bg-gray-100 hover:scale-110 active:scale-95 hover:shadow-md transition-all duration-200 ease-in-out"
                                  >
                                    <Trash2 size={14} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </>
        }

        {/* {tab === "Job" && (
         <div className="flex flex-wrap gap-3 py-2">
             <div
                
                  className={`flex items-center justify-between text-xs  text-[#b2853d] border border-[#f4e4c6] px-3 py-1 rounded-full shadow-sm cursor-pointer hover:bg-[#fff3e0] transition ${
                    selectedCategory?.name === 'Service Type'
                      ? "bg-[#fff3e0]"
                      : "bg-white"
                  }`}
                >
                  <span className="mr-2">Service Type</span>
                  <span className="bg-[#fffaf2] border border-[#f4e4c6] text-[#b2853d] text-[10px] font-semibold rounded-full px-2 py-[2px]">
                    89
                  </span>
                </div>
            </div>
        )} */}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                Confirm Deletion
              </h2>
              <button
                onClick={() => {
                  setDeleteCategoryItem(null);
                  setDeleteModalOpen(false);
                }}
                className="text-gray-400 hover:text-gray-500"
              >
                <X size={18} />
              </button>
            </div>
            <div className="mb-4 text-gray-700 text-sm">
              Are you sure you want to delete this item? This action cannot be
              undone.
            </div>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setDeleteCategoryItem(null);
                  setDeleteModalOpen(false);
                }}
                className=" px-4 py-2 text-sm rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 hover:scale-105 active:scale-95 transition-all duration-200 ease-in-out"
              >
                Cancel
              </button>
              <button
                onClick={() => {


                  handleCrudOperations();

                  // TODO: Handle delete action
                }}
                className="px-4 py-2 text-sm rounded-full bg-gradient text-white  hover:scale-105 active:scale-95 transition-all duration-200 ease-in-out"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Entity Modal */}
      {addEditModalOpen.state && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-800">
                {addEditModalOpen.type} {selectedCategory.name}
                <p className="text-xs text-gray-500">
                  {addEditModalOpen.type === "Add"
                    ? `Add a new ${selectedCategory.name}`
                    : `Update the details for this ${selectedCategory.name}`}
                </p>
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-gray-400 hover:text-gray-500"
              >
                <X size={18} />
              </button>
            </div>

            <div className="flex flex-col max-h-60 overflow-y-auto p-2">
              {selectedCategory?.name === "Project Phase Activity" ? (
                <>
                  <div className="flex flex-col">
                    <label className="text-xs text-gray-600 mt-3 mb-1">
                      Activity
                    </label>
                    <select
                      value={formData.activity_id || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          activity_id: Number(e.target.value),
                        }))
                      }
                      className="rounded-lg text-xs px-2 py-2 bg-gray-100 border border-gray-200 focus:outline-none focus:ring-0"
                    >
                      <option value="">Select Activity</option>
                      {activities.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.libelle}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs text-gray-600 mt-3 mb-1">
                      Project Phase
                    </label>
                    <select
                      value={formData.project_phase_id || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          project_phase_id: Number(e.target.value),
                        }))
                      }
                      className="rounded-lg text-xs px-2 py-2 bg-gray-100 border border-gray-200 focus:outline-none focus:ring-0"
                    >
                      <option value="">Select Project Phase</option>
                      {projectPhases.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.libelle}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              ) : selectedCategory?.name === "Sub Sector" ? (
                <>
                  <div className="flex flex-col">
                    <label className="text-xs text-gray-600 mt-3 mb-1">Sector</label>
                    <select
                      value={(formData.sector_ids && formData.sector_ids[0]) || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          sector_ids: e.target.value ? [Number(e.target.value)] : [],
                        }))
                      }
                      className="rounded-lg text-xs px-2 py-2 bg-gray-100 border border-gray-200 focus:outline-none focus:ring-0"
                    >
                      <option value="">Select Sector</option>
                      {sectors.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.libelle || s.name || s.value}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label className="text-xs text-gray-600 mt-3 mb-1">Code</label>
                    <input
                      type="number"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      placeholder="Enter number"
                      value={formData.code || ""}
                      disabled={addEditModalOpen.type === "Edit"}
                      onChange={(e) => {
                        // strip out any non-digit characters to enforce numeric-only input
                        const digits = String(e.target.value).replace(/\D/g, "");
                        setFormData((prev) => ({ ...prev, code: digits }));
                        const isEdit = addEditModalOpen.type === "Edit";
                        const error = validateField("code", digits, isEdit);
                        setValidationErrors((prev) => ({ ...prev, code: error }));
                      }}
                      className={`rounded-lg text-xs px-2 py-2 focus:outline-none focus:ring-0 bg-gray-100 border border-gray-200 ${
                        addEditModalOpen.type === "Edit" ? "bg-gray-200 cursor-not-allowed" : ""
                      }`}
                    />
                    {validationErrors.code && (
                      <p className="text-red-500 text-[10px] mt-1">{validationErrors.code}</p>
                    )}
                  </div>

                  <div className="flex flex-col">
                    <label className="text-xs text-gray-600 mt-3 mb-1">Name</label>
                    <input
                      type="text"
                      value={formData.name || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setFormData((prev) => ({ ...prev, name: newValue }));
                        const isEdit = addEditModalOpen.type === "Edit";
                        const error = validateField("name", newValue, isEdit);
                        setValidationErrors((prev) => ({ ...prev, name: error }));
                      }}
                      className="rounded-lg text-xs px-2 py-2 focus:outline-none focus:ring-0 bg-gray-100 border border-gray-200"
                    />
                    {validationErrors.name && (
                      <p className="text-red-500 text-[10px] mt-1">{validationErrors.name}</p>
                    )}
                  </div>
                </>
              ) : tableData.length > 0 ? (
                Object.keys(tableData[0])
                  .filter(
                    (key) => !(key === "id" && addEditModalOpen.type === "Add")
                  )
                  .map((key) => {
                    const prettyLabel = key
                      .split("_")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ");
                    return (
                      <div key={key} className="flex flex-col">
                        <label className="text-xs text-gray-600 mt-3 mb-1">
                          {prettyLabel}
                        </label>
                        <input
                          type={key === "code" ? "number" : "text"}
                          inputMode={key === "code" ? "numeric" : undefined}
                          pattern={key === "code" ? "[0-9]*" : undefined}
                          placeholder={key === "code" ? "Enter number" : "Enter text"}
                          value={formData[key] || ""}
                          disabled={
                            (key === "id" ||
                              key === "code" ||
                              key === "value") &&
                            addEditModalOpen.type === "Edit"
                          }
                          onChange={(e) => {
                            let newValue = e.target.value;
                            // For code field, strip non-digits
                            if (key === "code") {
                              newValue = newValue?.replace(/\D/g, "");
                            }
                            setFormData((prev) => ({
                              ...prev,
                              [key]: newValue,
                            }));
                            const isEdit = addEditModalOpen.type === "Edit";
                            const error = validateField(key, newValue, isEdit);
                            setValidationErrors((prev) => ({
                              ...prev,
                              [key]: error,
                            }));
                          }}
                          className={`rounded-lg text-xs px-2 py-2 focus:outline-none focus:ring-0 bg-gray-100 border border-gray-200 ${
                            ["id", "value", "code"].includes(key) &&
                            addEditModalOpen.type === "Edit"
                              ? "bg-gray-200 cursor-not-allowed"
                              : ""
                          }`}
                        />
                        {validationErrors[key] && (
                          <p className="text-red-500 text-[10px] mt-1">{validationErrors[key]}</p>
                        )}
                      </div>
                    );
                  })
              ) : (
                <p className="text-sm text-gray-500">
                  No fields available. Select a category first.
                </p>
              )}
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={handleCloseModal}
                className="p-2 px-4 text-xs rounded-full border border-gray-300 hover:bg-gray-100 hover:scale-105 active:scale-95 transition-all duration-200 ease-in-out"
              >
                Cancel
              </button>

              <button
                onClick={isSubmitDisabled ? undefined : handleCrudOperations}
                disabled={isSubmitDisabled}
                className={`p-2 px-6 text-xs rounded-full bg-gradient text-white ${isSubmitDisabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-90 hover:scale-105 active:scale-95"} transition-all duration-200 ease-in-out flex items-center justify-center`}
              >
                {handleCrudApiLoading ? (
                  <Loader2 className="animate-spin mr-2" size={16} />
                ) : addEditModalOpen.type === "Add" ? (
                  "Add"
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default Entities;
